module.exports = __webpack_public_path__ + "img/img0.9012fd87.jpg";